import React from 'react';

const Syllabus = () => {
  return (
    <div>
      Syllabus
      Syllabus
    </div>
  );
}

export default Syllabus;
